import { Button, Modal, Stack, TextInput } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { TRANS_KEY_FAVORITES } from '../../data';

export type SaveQueryModalPropsType = {
  opened: boolean;
  saveQueryName: string;
  onClose: () => void;
  onSaveQueryNameChange: (value: string) => void;
  onConfirm: () => void;
};

export const SaveQueryModal: React.FC<SaveQueryModalPropsType> = ({
  opened,
  saveQueryName,
  onClose,
  onSaveQueryNameChange,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t(`${TRANS_KEY_FAVORITES}.SAVE.MODAL.TITLE`)}
    >
      <Stack>
        <TextInput
          label={t(`${TRANS_KEY_FAVORITES}.SAVE.MODAL.NAME_LABEL`)}
          value={saveQueryName}
          onChange={(event) => onSaveQueryNameChange(event.currentTarget.value)}
        />
        <Button onClick={onConfirm} disabled={!saveQueryName.trim()}>
          {t(`${TRANS_KEY_FAVORITES}.SAVE.MODAL.CONFIRM_BUTTON`)}
        </Button>
      </Stack>
    </Modal>
  );
};
